// extracted by mini-css-extract-plugin
export default {"SubmenuContainer":"Submenu_SubmenuContainer__BTdxr","Selected":"Submenu_Selected__j813C"};